import moment from 'moment-timezone';

moment.createFromInputFallback = (config) => {
    config._d = new Date(NaN); // eslint-disable-line
};

export default moment;
